import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=c9867f7a&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=c9867f7a&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9867f7a')) {
      api.createRecord('c9867f7a', component.options)
    } else {
      api.reload('c9867f7a', component.options)
    }
    module.hot.accept("./ClientList.vue?vue&type=template&id=c9867f7a&", function () {
      api.rerender('c9867f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientList.vue"
export default component.exports